import { render, staticRenderFns } from "./MarketingBudget.vue?vue&type=template&id=632130be&scoped=true"
import script from "./MarketingBudget.vue?vue&type=script&lang=js"
export * from "./MarketingBudget.vue?vue&type=script&lang=js"
import style0 from "./MarketingBudget.vue?vue&type=style&index=0&id=632130be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632130be",
  null
  
)

export default component.exports